import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { Api } from '../../../services/api';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MdlSelectCompanyType } from '../../mdl-public-private/mdl-public-private';
import { MdlManageBudget } from '../../mdl-manage-budget/mdl-manage-budget';

@Component({
  selector: 'app-gest-com',
  imports: [CommonModule],
  templateUrl: './gest-com.html',
  styleUrl: './gest-com.css',
})
export class GestCom implements OnInit, OnChanges {
  @Input() contacto: any;

  public oportunidades: any[] = [];
  public presupuestos: any[] = [];

  private api = inject(Api);
  readonly dialog = inject(MatDialog);

  constructor() {}

  ngOnInit(): void {
    if (this.contacto) this.loadRelatedData();
  }
  ngOnChanges(): void {
    if (this.contacto) this.loadRelatedData();
  }

  loadRelatedData(): void {
    console.log('🔍 Cargando datos relacionados para contacto:', this.contacto);
    this.api
      .getOportunitiesByContact(this.contacto.contacto_id)
      .subscribe((response: any) => {
        if (Array.isArray(response.oportunidades)) {
          this.oportunidades = response.oportunidades;
          console.log('Oportunidades cargadas:', this.oportunidades);
        } else {
          console.error(
            'Respuesta inesperada al obtener oportunidades por contacto:',
            response
          );
        }
      });

      this.api.getBudgetsByContact(this.contacto.contacto_id)
      .subscribe((response: any) => {
        if (Array.isArray(response.presupuestos)) {
          this.presupuestos = response.presupuestos;
          console.log('Presupuestos cargados:', response.presupuestos);
        } else {
          console.error(
            'Respuesta inesperada al obtener presupuestos por contacto:',
            response
          );
        }});


      
  }

      openMdlCreateOportunity(): void {
          this.dialog.open(MdlSelectCompanyType,{
              minWidth: '800px',
              maxHeight: '900px',
              panelClass: 'mat-dlg-class',
              data:{
                  mode: 'create'
              }
          });
      }

         openMdlCreateBudget() {
              this.dialog.open(MdlManageBudget,{
                  minWidth: '800px',
                  maxHeight: '900px',
                  panelClass: 'mat-dlg-class',
                  data:{
                      mode: 'create'
                  }
              })
          }
  
}
